"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numToPercentage = exports.numToCurrency = void 0;
require("core-js/modules/es.number.to-fixed.js");
// takes number and returns currency string as dollar amount (1234 => '$1,234')
var numToCurrency = exports.numToCurrency = function numToCurrency(_num) {
  return _num.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
};

// takes number as fraction and returns precent as string (0.035 => '3.5%')
var numToPercentage = exports.numToPercentage = function numToPercentage(_num) {
  var num = _num * 100;
  return "".concat(num.toFixed(1), "%");
};